<template>
    <div id="wrap">
      <div class="content_box">
        <img :src="success" alt="">
        <div :class="['title',{'title-center':$route.query.isShowScore == 0}]">
          <h1 v-if="$route.query.value==0">恭喜您，交卷成功！</h1>
          <h1 v-else>考试时间结束，已自动交卷！</h1>
          <p v-if="$route.query.isShowScore != 0"><span>{{number}}</span><span>秒后将自动跳转到作答详情页</span></p>
          <!-- <p v-if="$route.query.flag===false"><span>{{number}}</span><span>秒后将自动跳转到考试初始有</span></p>
          <p v-if="$route.query.flag===false" ><span>教师公布答案后可查看作答详情</span></p> -->
        </div>
      </div>
    </div>
</template>

<script>
   import Header from "../testComponent/header";
   import testSuccess from "../../img/testSuccess.png";
    export default {
        name: "test-success",
        data(){
          return{
            success:testSuccess,
            number:3,
          }
        },
        components:{
          Header:Header,
        },
        mounted(){
          let that = this;
          if (this.$route.query.isShowScore == 0) return
          let timer = setInterval(function(){
             that.number--;
            //  console.log(that.$route.query.flag)
             if(that.number === 0){
                clearInterval(timer);
              //  if(that.$route.query.flag===true){
                 console.log(111)
                   that.$router.push({
                   path: '/switch/test/stupreview',
                   query: {
                     id: that.$route.query.id,
                     classId: that.$route.query.classId,
                     userId: sessionStorage.getItem('userId'),
                     paperId: that.$route.query.paperId,
                     total: that.$route.query.total,
                     className: that.$route.query.className,
										 paperCode: that.$route.query.paperCode,
										 examId: that.$route.query.examId,
                     finishFlag:0
                   }
                  });
              //  }else{
              //    console.log(222)
              //     that.$router.push({
              //       path: '/switch/examination/index',
              //       query: {
              //         id: that.$route.query.id,
              //         classId: that.$route.query.classId,
              //         className: that.$route.query.classNames,
              //       }
              //     });
              //  }
              
              
             }
          },1000);
        }
    }
</script>

<style lang="scss" scoped>
  #wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .content_box{
      width:640px;
      height:200px;
      background:rgba(255,255,255,1);
      box-shadow:0px 4px 12px rgba(216,216,216,1);
      opacity:1;
      border-radius:8px;
      img{
        width: 72px;
        height: 72px;
        float: left;
        margin-left:145px;
        margin-top:64px;
      }
      .title{
        margin-left:16px;
        margin-top:70px;
        float: left;

        &.title-center {
          margin-top: 88px;
        }
        h1{
          font-size:24px;
          font-weight:bold;
        }
        p{
          font-size:18px;
          margin-top:16px;
          span:nth-child(1){
            color:red;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testComponent/testSuccess.vue